import { getSourcePathAccessor } from "../utils";
import { PriceRateOfChange as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    const { period, sourcePath } = options;

    if (!period || period < 1) {
      throw new Error("Price ROC period must be at least 1");
    }

    if (data.length <= period) {
      return new Array(data.length).fill(undefined);
    }

    // Accessor for price field
    const getPrice = getSourcePathAccessor(sourcePath);
    const results = new Array(data.length).fill(undefined);

    for (let i = period; i < data.length; i++) {
      const current = data[i];
      const past = data[i - period];

      if (!current || !past) {
        continue;
      }

      // Extract and convert price values to numbers
      const currentPrice = Number(getPrice(current));
      const pastPrice = Number(getPrice(past));

      // Validate values and calculate ROC
      if (
        Number.isFinite(currentPrice) &&
        Number.isFinite(pastPrice) &&
        pastPrice !== 0
      ) {
        // Calculate Rate of Change: 100 * ((current / past) - 1)
        results[i] = 100 * (currentPrice / pastPrice - 1);
      }
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return options.period;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
